import React from 'react';

const DEFAULT_TRUST_BADGES = [
  {
    _id: 'default-1',
    title: 'Envío Gratis',
    description: 'En compras superiores a $3.000 a todo el país con seguimiento incluido.',
    icon: 'fa-solid fa-truck-fast'
  },
  {
    _id: 'default-2',
    title: 'Cambios Fáciles',
    description: '30 días para cambios y devoluciones sin complicaciones.',
    icon: 'fa-solid fa-arrow-rotate-left'
  },
  {
    _id: 'default-3',
    title: 'Pago Seguro',
    description: 'Hasta 6 cuotas sin interés con Mercado Pago.',
    icon: 'fa-solid fa-shield-halved'
  },
  {
    _id: 'default-4',
    title: 'Calidad Premium',
    description: 'Materiales seleccionados y confección de primera calidad.',
    icon: 'fa-solid fa-gem'
  }
];

const ServicesSection = ({ services }) => {
  const enabled = services?.enabled !== false;
  const badges = services?.badges?.length > 0
    ? services.badges
    : DEFAULT_TRUST_BADGES;

  if (!enabled) {
    return null;
  }

  return (
    <section style={{
      padding: 'clamp(40px, 8vw, 80px) clamp(16px, 4vw, 40px)',
      background: 'var(--bg-secondary)'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div className="services-badges-grid" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '24px'
        }}>
          {badges.map((badge, index) => (
            <div key={badge._id || `badge-${index}`} className="services-badge-item" style={{
              textAlign: 'center',
              padding: '32px 20px'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--border-medium)',
                background: 'var(--bg-white)'
              }}>
                <i className={badge.icon} style={{
                  fontSize: '1rem',
                  color: 'var(--text-primary)'
                }}></i>
              </div>
              <h4 style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.78rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'var(--text-primary)',
                marginBottom: '10px'
              }}>
                {badge.title}
              </h4>
              <p style={{
                color: 'var(--text-muted)',
                fontSize: '0.82rem',
                lineHeight: 1.6,
                margin: 0
              }}>
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .services-badge-item {
          flex: 0 0 auto;
          width: calc(25% - 18px);
        }
        @media (max-width: 992px) {
          .services-badge-item {
            width: calc(50% - 12px);
          }
        }
        @media (max-width: 576px) {
          .services-badge-item {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
